<!--
 * @FileDescription: 销售订单——全部tab页
 * @Author: ryb（作者）
 * @Date: 2020-07-16（时间）
 -->
<template>
  <div class="abnormal-table-list">
    <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id" :scroll="{ y: tableHeight }"
      bordered>
      <template slot="serialNum" slot-scope="text, record, index">
        <span>{{  index+1 }}</span>
      </template>
      <!-- 商品名称 -->
      <template slot="productName" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">
            <span>{{ text }}</span>
          </template>
          <div class="text-overflow">
            <img src="@/assets/image/zengpin.png" style="width: 22px;margin-right: 5px" v-if="record.giftFlag==1">
            <img src="@/assets/image/manage_zong@2x.png" style="width: 22px" v-if="record.assemblyFlag==1">
            <span class="name-text"> {{ text }}</span>
          </div>
        </a-tooltip>
      </template>
      <!-- 状态 -->
      <template slot="status" slot-scope="text">
        <div class="order-staus">
          <!-- <span class="status-round"
            :style="{backgroundColor:text==1?'#FF0000' :text==2?'#F76F14' :text==6?'#AAAAAA' :'#199A2C'}"></span>
          <span
            :style="{color: text==1?'#FF0000' :text==2?'#F76F14' :text==3?'#199A2C' :text==4?'#333333' :text==5?'#555555' :'#AAAAAA'}">
            {{  text==1?"待支付" :text==2?"待发货" :text==3?"待收货" :text==4?"已收货" :text==5?"已完成" :"已关闭" }}
          </span> -->
          <div class="order-staus-left">
            <span class="status-round"
              :style="{backgroundColor:text==1?'#F76F14' :text==2?'#F0320C' :text==5?'#AAAAAA' :'#35AD00'}"></span>
          </div>
          <div class="order-staus-right">
            <a-row v-if="text==1">
              <a-col style="color:#F76F14">待审核</a-col>
            </a-row>
            <a-row v-if="text==2">
              <a-col style="color:#F0320C">审核拒绝</a-col>
              <a-col style="color:#387BFC" class="refuse-reason">原因：还不是你长得不好还不是你长得不好还不是你长得不好</a-col>
            </a-row>
            <a-row v-if="text==3">
              <a-col>审核通过已退款</a-col>
            </a-row>
            <a-row v-if="text==4">
              <a-col>审核通过待退款</a-col>
            </a-row>
            <a-row v-if="text==5">
              <a-col style="color:#AAAAAA">已撤回</a-col>
            </a-row>
          </div>
        </div>
      </template>
      <template slot="operation" slot-scope="text, record">
        <span style="color: #387BFC;cursor: pointer;" @click="btnGoSalesOrderDetails(record)">查看</span>
      </template>
    </a-table>
  </div>
</template>
<script>
import { tableWidth } from "@/mixins/tableWidth";
import { abnormal } from "../method/abnormal";
export default {
  mixins: [abnormal, tableWidth],
  data() {
    return {
      columns: [
        {
          title: "序号",
          align: "center",
          width: 80,
          dataIndex: "serialNum",
          scopedSlots: { customRender: "serialNum" },
        },
        {
          defaultWidth: 180,
          title: "订单商品",
          dataIndex: "productName",
          ellipsis: true,
        },
        {
          defaultWidth: 180,
          title: "单据编号",
          dataIndex: "code",
          ellipsis: true,
        },
        {
          defaultWidth: 130,
          title: "单据日期",
          ellipsis: true,
          dataIndex: "voucherDate",
        },
        {
          defaultWidth: 130,
          title: "审核时间",
          ellipsis: true,
          dataIndex: "shenhe",
        },
        // {
        //   title: "经办人",
        //   ellipsis: true,
        //   dataIndex: "transactorName",
        // },
        {
          defaultWidth: 90,
          title: "金额",
          ellipsis: true,
          align: "right",
          dataIndex: "totalAmount",
          scopedSlots: { customRender: "totalAmount" },
        },
        {
          title: "收货人",
          ellipsis: true,
          dataIndex: "shouhuoren",
        },
        {
          title: "发货门店",
          ellipsis: true,
          dataIndex: "fahuomendian",
        },
        {
          defaultWidth: 90,
          title: "数量",
          ellipsis: true,
          dataIndex: "shuliang",
        },
        {
          defaultWidth: 180,
          title: "备注",
          ellipsis: true,
          dataIndex: "beizhu",
        },
        {
          defaultWidth: 180,
          title: "状态",
          ellipsis: true,
          dataIndex: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          align: "center",
          dataIndex: "operation",
          ellipsis: true,
          scopedSlots: { customRender: "operation" },
        },
      ],
      urlList: {},
    };
  },
  methods: {
    // 查看详情
    btnGoSalesOrderDetails(record) {
      this.$router.push({
        path:
          "/cloudstore/sales/selladmin/salesOrderDetails?id=1&&type=" +
          record.status,
      });
    },
  },
};
</script>

<style lang="scss">
.abnormal-table-list {
  .order-staus {
    height: 100%;
    display: flex;
    align-items: center;
    .status-round {
      display: inline-block;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      margin-right: 6px;
    }
    .refuse-reason {
      width: 160px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .text-overflow {
    width: 100%;
    height: 36px;
    line-height: 36px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .name-text {
      padding-left: 5px;
    }
  }
}
</style>
